module.exports = __webpack_public_path__ + "0b825afa3c4e319c3df9ff9151cf2442.svg";